export default {
  dashboard: {
    pageTitle: "Panel de Control",
    loading: "Cargando…",

    reportTooltip: "Descarga un PDF ejecutivo con los eventos del mes en tu portfolio, tu competencia y el radar regulatorio",
    reportError: "Error al generar",
    reportGenerating: "Generando informe…",
    reportLabel: "Informe mensual (PDF)",

    errorTitle: "No se pudo conectar con el servidor",
    errorBody: "El API no está disponible temporalmente. Esto puede ocurrir durante reinicios. Espera unos segundos y recarga.",
    retry: "Reintentar",

    kpiToday: "Eventos hoy",
    kpiTodaySub: "últimas 24 h",
    kpiWeek: "Eventos esta semana",
    kpiWeekSub: "últimos 7 días",
    kpiPortfolio: "Afectan portfolio",
    kpiCompetitors: "Afectan competidores",
    last30Days: "últimos 30 días",
    brandsSub: "últimos 30 días · {cn} CN · {brands} marcas",
    lastDataAt: "Último dato: {date}",
    lastDataNone: "Sin datos todavía",

    navToday: "Eventos hoy",
    navWeek: "Eventos últimos 7 días",
    // Panel 2×3 (R-15, §89)
    rowPortfolio: "Portfolio",
    rowCompetitors: "Competencia",
    kpiTodayShort: "Hoy",
    kpiWeekShort: "7 días",
    kpiMonthShort: "30 días",
    navPortfolioToday: "Portfolio — hoy",
    navPortfolioWeek: "Portfolio — últimos 7 días",
    navCompetitorsToday: "Competidores — hoy",
    navCompetitorsWeek: "Competidores — últimos 7 días",
    // R-08 (§90 Fase 2A)
    noPortfolioWarning: "Estás vigilando sin productos propios: todo lo que ves es mercado. Da de alta tu cartera para que HelixScan distinga lo tuyo de la competencia.",
    noPortfolioCta: "Añadir mis productos",
    navPortfolio: "Portfolio — últimos 30 días",
    navCompetitors: "Competidores — últimos 30 días",

    recentChanges: "Eventos recientes",
    viewAll: "Ver todos →",
    colDate: "Fecha",
    colPrio: "Prio.",
    colType: "Tipo",
    colProduct: "Producto",
    colActiveIngredient: "Principio Activo",
    noChangesYet: "Sin eventos detectados aún",
    viewProductTooltip: "Ver ficha de {name}",

    recentActivity: "Actividad Reciente",
    viewHistory: "Ver histórico →",
    today: "Hoy",
    yesterday: "Ayer",
    noChanges: "Sin eventos",

    sourcesStatus: "Estado de Fuentes",
    sourceDisabled: "Fuente desactivada",
    lastLabel: "Última:",
    nextLabel: "Próxima:",
    statusOk: "OK",
    statusWarning: "AVISO",
    statusError: "ERROR",
    statusInactive: "INACTIVA",
    statusPending: "PENDIENTE",

    typeNewEntry: "Nueva entrada",
    typePriceChange: "Cambio precio",
    typeReimbursementChange: "Financiación",
    typeExclusion: "Exclusión",
    typeDeduction: "Deducción",
    typeWarning: "Nota",
    typeMarketingStatus: "Comercialización",
    typeEuRegistration: "Registro europeo",
    typeExclusivity: "Exclusividad",
  },
};
